import { Navigate } from "react-router-dom";

const RootRedirect = () => {
  const token = localStorage.getItem("token");
  const role = (localStorage.getItem("role") || "").toLowerCase();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (role === "admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (role === "hr") {
    return <Navigate to="/hr/dashboard" replace />;
  }

  if (role === "member") {
    return <Navigate to="/member/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default RootRedirect;